import { Entity } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetEntitiesQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/entities?limit=10000`
	return useQuery<void, EntitiesOutput>(url)
}
interface EntitiesOutput {
	entities: Entity[]
}
